<template>
    <StreamlineIcon
        class="LoadingIcon"
        :icon="icon"
        :stroke="color"
        :size="size"
    />
</template>
<script>
import {SynchronizeArrows1} from "@reviewpush/streamline-regular/lib/interface-essential/Synchronize";
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import colors from 'style/_colors.scss';

export default {
    name: 'RPLoadingIcon',
    components: {
        StreamlineIcon
    },
    props: {
        /**
         * Size in pixels
         */
        size: {
            default: 16,
            type: Number,
        },
        /**
         * Any valid CSS color
         */
        color: {
            type: String,
            default: colors.secondaryPurple,
        }
    },
    data(){
        return {
            icon: SynchronizeArrows1,
        };
    }
};
</script>
<style lang="scss">
    @keyframes spin {
        from {
            transform: scaleX(-1) rotate(0deg);
        }
        to {
            transform: scaleX(-1) rotate(-359deg);
        }
    }
    .LoadingIcon {
        display: flex;
        > svg {
            animation: spin 2.5s linear infinite;
        }
    }
</style>

<docs>
```vue
<RPLoadingIcon />
<br>
<RPLoadingIcon color="green" :size="24" />
```
</docs>
